export default {
  beforeRouteLeave(to, from, next) {
    const form = this.$refs.form
    if (!form || form.persistDraft() || !form.dirty) {
      next()
      return
    }
    this.$dialog
      .confirm({
        title: '草稿无法保留',
        message: '当前浏览器无法保留填写内容，离开会丢失未保存的修改。是否离开？'
      })
      .then(() => next(), () => next(false))
  }
}



// WEBPACK FOOTER //
// ./src/common/form-route.js